<!--地图-->
<template>
	<div class="mapBody mywebmap">
		<div id="allmap"></div>
	</div>
</template>

<script type="text/javascript">
	export default {
		components: {},
		props: [],
		data() {
			return {
				subtree: [],
				markerArr: [],
				map: undefined,
				clickTree: undefined,
				opts: {
					width: 250, // 信息窗口宽度
					height: 80, // 信息窗口高度
					title: "信息窗口", // 信息窗口标题
					enableMessage: true //设置允许信息窗发送短息
				},
				markList: [],
				mapBianjeiData: undefined,
			}
		},
		created() {},
		mounted() {
			this.initMap()
		},
		destroyed() {
		},
		computed: {
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			pointLists() {
				if(isempty(this.nowUnit)) {
					return []
				}
				return treeToList(this.nowUnit, 'next', function(e) {
					return e.next != undefined && e.next.length > 0
				}).reverse()
			},
			zoomLevel() {
				if(isempty(this.$store.cacheStore.getters.getWebConfig.ZoomLevel)) {
					return 12
				}
				return this.$store.cacheStore.getters.getWebConfig.ZoomLevel
			},
			centerPointList() {
				if(isempty(this.$store.cacheStore.getters.getWebConfig.CenterPoint)) {
					return []
				}
				return this.$store.cacheStore.getters.getWebConfig.CenterPoint.split(',')
			},
		},
		watch: {
			nowUnit(nv, ov) {
				//单位切换了，刷新图符
				for(var i = 0, len = this.markList.length; i < len; i++) {
					var item = this.markList[i]
					item.remove()
				}
			},
			pointLists(nv, ov) {
				this.initMap()
			},
		},
		methods: {
			//向地图添加标记点
			addMarker(point, data) {
				if(isempty(point) || isempty(point.lng) || isempty(point.lat)) {
					return
				}
				this.map.centerAndZoom(new BMap.Point(point.lng, point.lat), 11);
				var marker = new BMap.Marker(point); //创建标注
				//提示框
				var label = new BMap.Label('', {
					offset: new BMap.Size(20, -10)
				});
				label.setStyle({
					borderColor: "#808080",
					color: "#333",
					cursor: "pointer"
				});
				marker.setLabel(label);
				marker.addEventListener("click", clikcEvent => {
					//设置当前选中的单位
					this.$store.unitStore.commit('setNowUnit', data.id)
					//跳转到连接中带的位置，默认是usePowerUnit
					var params = window.location.href.subByFirstChar('?').split("&").map(item => {
						var l = item.split("=")
						return {
							key: l[0],
							value: l[1]
						}
					})
					if(params.length == 1 && params[0].key.includes("webMap")) {
						this.$router.push("/usePowerUnit")
						return
					}
					if(isempty(params)) {
						this.$router.push("/usePowerUnit")
					} else {
						for(var i = 0, len = params.length; i < len; i++) {
							var item = params[i]
							if(item.key == 'target') {
								switch(item.value) {
									case 'siemensHomePage':
										this.$router.push("/siemensHomePage")
										break
								}
							}
						}
					}
				});
				//详细信息框
				var html = "<div class='bmapInfo'>" +
					"<div class='bmapInfo_title'><p>" + data.name + "</p></div>" +
					"<div class='bmapInfo_cont'><p>地址：" + data.address + " </p></div></div>";
				var infoWindow = new BMap.InfoWindow(html, {
					offset: {
						width: 0,
						height: -20
					}
				});
				//往上移动20px
				marker.addEventListener("mouseover", () => {
					this.map.openInfoWindow(infoWindow, point);
				});
				this.map.addOverlay(marker);
				this.markList.push(marker)
				this.$emit('updateMap')
			},
			//把data转换成 百度地图point
			dataToPoint(data) {
				if(isempty(data) || isempty(data.location)) {
					return {}
				}
				var lnglatArray = data.location.split(',') //切成 数组
				if(lnglatArray.length != 2) {
					return {}
				}
				var lng = parseFloat(lnglatArray[0])
				var lat = parseFloat(lnglatArray[1])
				return new BMap.Point(lng, lat);
			},
			initMap() {
				if(typeof(BMap) == 'undefined') {
					return
				}
				this.map = new BMap.Map("allmap", {
					mapType: BMAP_HYBRID_MAP
				})
				var hasLocation = false
				for(var i = 0, len = this.pointLists.length; i < len; i++) {
					var tempData = this.pointLists[i]
					if(!isempty(tempData.location)) {
						var point = this.dataToPoint(tempData);
						this.addMarker(point, tempData)
						hasLocation = true
					}
				}
				if(this.pointLists.length == 0 || !hasLocation) {
					this.map.centerAndZoom(new BMap.Point(116.404, 39.915), 11);
				}
				this.map.addControl(new BMap.MapTypeControl({
					mapTypes: [
						BMAP_HYBRID_MAP,
						BMAP_NORMAL_MAP
					]
				}));
				this.map.enableScrollWheelZoom(true);
				var axios = require('axios')
				axios({
					url: "/static/杭州东杰定制/看板/地图/boundaryBean.json",
				}).then(respon => {
					this.mapBianjeiData = JSON.parse(JSON.stringify(respon.data))
					this.addBoundary(this.mapBianjeiData)
				})
			},
			addBoundary(boundaryBean) {
				//设置边界
				var bdary = new BMap.Boundary()
				var yh = boundaryBean.features[0].geometry.coordinates[0]
				for(var i = 0, len = yh.length; i < len; i++) {
					var item = yh[i]
					var ps = ''
					yh.forEach(item => {
						item.forEach((item2, index) => {
							if(index + 1 < item.length) {
								ps += item2[0] + ',' + item2[1] + ';'
							} else {
								ps += item2[0] + ',' + item2[1]
							}
						})
					})
					var ply = new BMap.Polygon(ps, {
						strokeColor: '#3682f2',
						strokeWeight: 2,
						strokeOpacity: 1,
						strokeStyle: "solid",
						fillColor: '#5e9bf5',
						fillOpacity: .15,
						enableClicking: !1,
					})
					this.map.addOverlay(ply)
				}
			}
		}
	}
</script>

<style scoped lang="scss">
	.mapBody {
       padding: 0px !important;
	}
	.mywebmap {
      padding: 0px !important;
	}
	#allmap {
		width: 100%;
		height: 100%;
	}
	
	.BMap_pop {}
</style>